import type { AuditSubRow } from './auditEventHelpers';

/** One field change in an audit event: small-caps label, then before → after. */
export function AuditSubRowLine({ row }: { row: AuditSubRow }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 8,
        marginTop: 4,
      }}
    >
      {row.label && (
        <span
          style={{
            flexShrink: 0,
            width: 64,
            fontSize: 9,
            fontWeight: 700,
            letterSpacing: '.07em',
            textTransform: 'uppercase',
            color: 'var(--nb-subtle)',
          }}
        >
          {row.label}
        </span>
      )}
      <span className="nb-mono" style={{ fontSize: 10.5, color: 'var(--nb-muted)' }}>
        <span style={{ textDecoration: 'line-through', color: 'var(--nb-subtle)' }}>
          {row.beforeStr}
        </span>
        {' → '}
        <span style={{ color: 'var(--nb-ink)' }}>{row.afterStr}</span>
      </span>
    </div>
  );
}
